import React from 'react';
import LatexRenderer from './LatexRenderer';

/**
 * QuestionText Component
 * Displays question text with smart LaTeX handling
 * - Clean text with parsed superscripts/subscripts inline
 * - Collapsible section for complex LaTeX (equations, tables)
 */
const QuestionText = ({
    cleanText,
    fullTextLatex,
    className = '',
    showLatexByDefault = false
}) => {

    // Check if there's complex LaTeX to show
    const hasComplexLatex = fullTextLatex && (
        fullTextLatex.includes('\\begin{') ||
        fullTextLatex.includes('\\frac{') ||
        fullTextLatex.includes('\\sum') ||
        fullTextLatex.includes('\\int') ||
        fullTextLatex.includes('\\matrix') ||
        fullTextLatex.includes('$$')
    );

    return (
        <div className={`question-text-container ${className}`}>
            {/* Main question text - clean and readable */}
            <div className="question-text-main text-gray-800 leading-relaxed">
                <LatexRenderer mode="inline">
                    {cleanText}
                </LatexRenderer>
            </div>

            {/* LaTeX section - for equations */}
            {hasComplexLatex && (
                <div className="latex-section mt-2 flex items-start gap-3">
                    <span className="text-sm font-bold text-gray-700 mt-1.5 shrink-0">Equation:</span>
                    <div className="latex-content-block px-3 py-1.5 bg-gray-50 rounded-md border border-gray-200 overflow-x-auto">
                        <LatexRenderer mode="inline">
                            {fullTextLatex}
                        </LatexRenderer>
                    </div>
                </div>
            )}
        </div>
    );
};

export default QuestionText;
